/** localStorage flag set on a device an admin has used; it is never tracked. */
export const ADMIN_DEVICE_KEY = 'analytics_admin_device'

/**
 * localStorage flag set on a device whose user made or opened their own link
 * for one company (utils/applicationLink.ts): their visits to it never count
 * as the company opening it, signed in or not.
 */
export const LINK_OWNER_DEVICE_KEY = 'imr_link_owner_device'

/**
 * Pages of a link for one company (/r/<token>). The visitor is a recruiter,
 * not our user: the site's own visitor tracking (plugins/analytics.client.ts)
 * stays off there, and the page counts openings its own way, keeping nothing
 * in their browser.
 */
export const LINK_PAGE_PREFIX = '/r/'
